export default __webpack_public_path__ + "static/app-cross-platform-vantaggi-per-aziende-orangeloop-6933237d9770b5212a94fc465a80676d.jpg";